<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="doc.title"
            type="text"
            placeholder="Group title"
            id="title"
          ></v-text-field>
         
          <v-color-picker class="ma-2"   v-model.trim="doc.colour" :swatches="swatches" show-swatches></v-color-picker>

           <v-select
            :items="projects"
            item-value="id" item-text="title"
            v-model.trim="doc.project"
            @change="selectUsers"
            label="Projects"
          >
          </v-select>
        </v-col>
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">User</th>
                  <th class="text-left">Selected</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in users" :key="item.name">
                  <td>{{ item.first }}</td>
                  <td>{{ item.last }}</td>
                  <td>
                    <v-switch v-model="item.selected" class="ma-2"></v-switch>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");

export default {
  name: "AdminGroupUpload",
  data() {
    return {
      users: null,
      projects: null,
      dropdownCategories: ["Red", "Green", "Blue", "Yellow"],
       swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
    };
  },
  props: {
    doc: Object,
  },
  computed: {
    selectedUsers() {
      if (this.users) {
        return this.users.filter((item) => item.selected === true);
      } else {
        return false;
      }
    },
    projectsMenu() {
      return this.projects.map(item => item.title);
    }
  },
  watch: {
    selectedUsers(val) {
      this.doc.users = val;
    },
  },
  methods: {
    selectUsers(val) {
      const ref = fb.projectsCollection.doc(val);
      ref.get().then((doc) => {
        if (doc.exists) {
          let items = [];
          let d = doc.data();
          d.users.forEach((user) => {
            items.push(user);
          });
          this.users = items;
        } else {
          alert("No such document!");
        }
      });
    }
  },
  created() {
      fb.projectsCollection
      .get()
      .then((docs) => {
        let items = [];
        docs.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.projects = items;
      })
      .catch(() => {

      });
  },
};
</script>
